import {MatPaginatorIntl} from '@angular/material/paginator';

const rangeLabel: string = 'von';
const itemsPerPageLabel: string = 'Elemente pro Seite:';
const firstPageLabel: string = 'Erste Seite';
const lastPageLabel: string = 'Letzte Seite';
const previousPageLabel: string = 'Vorherige Seite';
const nextPageLabel: string = 'Nächste Seite';

const getRangeLabel: (page: number, pageSize: number, length: number) => string = (
    page: number,
    pageSize: number,
    length: number
): string => new MatPaginatorIntl().getRangeLabel(page, pageSize, length).replace(/[a-z]+/i, rangeLabel);

export class CustomPaginator extends MatPaginatorIntl {
  constructor() {
    super();
    this.itemsPerPageLabel = itemsPerPageLabel;
    this.firstPageLabel = firstPageLabel;
    this.lastPageLabel = lastPageLabel;
    this.previousPageLabel = previousPageLabel;
    this.nextPageLabel = nextPageLabel;
    this.getRangeLabel = getRangeLabel;
  }
}
